export default __webpack_public_path__ + "static/media/sailors-tale-012-3411-00.a9687ada.jpg";